import API from '@/api'

export default {
    state: {
        tickets: [],
        filters: {
            type: 'all',
            search: '',
        },
        isModal: false,
        isViewed: 0
    },
    mutations: {
        setTickets(state, payload) {
            state.tickets = payload;
        },
        filteredTickets(state, payload) {
            state.filtered = payload
        },

        closeModal(state) {
            state.isModal = false
        },
        openModal(state) {
            state.isModal = true
        },
        setType(state, payload){
            state.filters.type= payload
        }
    },
    actions: {
        getTickets({commit, state}) {
            API.tickets.get(20, 1).then(res => {
                commit('setTickets', res.data.data);
            });
        },
        ticketsFilter({commit, state}, type) {
            commit("filteredTickets", state.tickets.filter(el => el.status === type))
        },

        isViewed({commit, state}) {
            return API.tickets.isViewed().then(res => {
                state.isViewed = res.data.count;
                return res;
            });
        },
        viewed({commit, state, dispatch}, id) {
            return API.tickets.viewed(id).then(res => {
                dispatch('isViewed');
                return res;
            });
        },

    },
    getters: {
        getTickets: state => state.tickets,
        getFilters: state => state.filters,
        getModal: state => state.isModal,
        getViewed: state => {
            return state.isViewed > 0 ? false : true;
        },
    }
};
